import React, { useState, useEffect } from 'react';

type Props = {
  checkboxList: Array<number>;
  setIsPanelClosed: React.Dispatch<React.SetStateAction<boolean>>;
  name: string;
  children?: any;
};

export const RightMenu: React.FC<Props> = ({
  checkboxList,
  children,
  setIsPanelClosed,
  name,
}) => {
  const [openCloseState, setOpenCloseState] = useState<string>('Closed');

  useEffect(() => {
    if (checkboxList.length) {
      setIsPanelClosed(false);
      setOpenCloseState('Open');
    } else {
      setIsPanelClosed(true);
      setOpenCloseState('Closed');
    }
  }, [checkboxList]);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child as React.ReactElement, { openCloseState, checkboxList, name });
    }
    return child;
  });

  return <React.Fragment>{childrenWithProps}</React.Fragment>;
};
